import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image, Button } from '@deal/components'
import ChevronUp from './chevron-up.svg'
import ChevronDown from './chevron-down.svg'
import { ChatLeadComponent, MessageRichCardType } from '#src/generated/graphql'
import styles from './styles.css'
import CategoryIcon from '#src/components/CategoryIcon'

interface State {
  showAllAttributes: boolean
}

export default class ProductCuration extends Component<MessageComponentProps, State> {
  constructor(props: MessageComponentProps) {
    super(props)

    this.state = { showAllAttributes: false }

    this.handleShowFewer = this.handleShowFewer.bind(this)
    this.handleShowMore = this.handleShowMore.bind(this)
  }
  public static handlesMessage(message: FirebaseMessage) {
    return (
      (message.parts[0].body.type === 'new-lead-rich-seq-dealbot-confirms-request' ||
        message.parts[0].body.richCardType ===
          MessageRichCardType.ONBOARDING_REQUEST_CONFIRMATION) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.leadId
    )
  }

  public handleShowMore() {
    this.setState({ showAllAttributes: true })
  }

  public handleShowFewer() {
    this.setState({ showAllAttributes: false })
  }

  public render() {
    const { leadId } = this.props.message.parts[0].body.queryVariables
    const { showAllAttributes } = this.state
    return (
      <ChatLeadComponent variables={{ leadId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.lead) {
            const { consumer, latestRequest } = data.lead
            // No point in rendering this card if you don't have a latest request or category
            if (!latestRequest || !data.lead.category) return null

            const category = data.lead.category
            const attributes = latestRequest.attributes
              ? latestRequest.attributes.filter(attribute => !!attribute.formatted)
              : []
            const attributesToShow = showAllAttributes ? attributes : attributes.slice(0, 3)

            const banner =
              category.contentAssets &&
              category.contentAssets.bannerImages &&
              category.contentAssets.bannerImages[0]

            return (
              <MessageBubble message={this.props.message}>
                <div className={styles.hero}>
                  {banner &&
                    banner.imageUrl && (
                      <Image
                        src={banner.imageUrl}
                        width={384}
                        height={134}
                        imgixParams={{ fit: 'crop' }}
                        className={styles.heroImage}
                        onMounted={this.props.onLoaded}
                      />
                    )}

                  <div className={styles.overlay}>
                    {category && (
                      <>
                        <CategoryIcon
                          className={styles.categoryIcon}
                          categoryName={category.name}
                        />
                        <div className={styles.break} />
                        {`${
                          consumer.firstName
                        }'s ${category.singularDisplayName.toLowerCase()} request`}
                      </>
                    )}
                  </div>
                </div>
                <div className={styles.requestDetails}>
                  <div className={styles.categoryName}>
                    {category.singularDisplayName} request details
                  </div>
                  {attributesToShow.map(attribute => (
                    <div key={attribute.formatted!.name} className={styles.attribute}>
                      <div className={styles.attributeName}>{attribute.formatted!.name}</div>
                      <div
                        dangerouslySetInnerHTML={{ __html: attribute.formatted!.displayHtml }}
                        className={styles.attributeValue}
                      />
                    </div>
                  ))}
                  {attributes.length > 3 && (
                    <div className={styles.seeMoreRow}>
                      {showAllAttributes ? (
                        <Button
                          variant="link"
                          size="small"
                          className={styles.showMore}
                          onClick={this.handleShowFewer}
                        >
                          Collapse Details <ChevronUp className={styles.chevron} />
                        </Button>
                      ) : (
                        <Button
                          variant="link"
                          size="small"
                          className={styles.showMore}
                          onClick={this.handleShowMore}
                        >
                          Expand All Details <ChevronDown className={styles.chevron} />
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </MessageBubble>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading message!
              </MessageBubbleText>
            )
          }
        }}
      </ChatLeadComponent>
    )
  }
}
